/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListShadowMCPInventoryServersForUser } from "../funcs/accessListShadowMCPInventoryServersForUser.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListShadowMCPInventoryResult } from "../models/components/listshadowmcpinventoryresult.js";
import {
  ListShadowMCPInventoryServersForUserRequest,
  ListShadowMCPInventoryServersForUserSecurity,
} from "../models/operations/listshadowmcpinventoryserversforuser.js";
import { unwrapAsync } from "../types/fp.js";
export type ShadowMCPInventoryServersForUserQueryData =
  ListShadowMCPInventoryResult;

export function prefetchShadowMCPInventoryServersForUser(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListShadowMCPInventoryServersForUserRequest,
  security?: ListShadowMCPInventoryServersForUserSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildShadowMCPInventoryServersForUserQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildShadowMCPInventoryServersForUserQuery(
  client$: GramCore,
  request: ListShadowMCPInventoryServersForUserRequest,
  security?: ListShadowMCPInventoryServersForUserSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ShadowMCPInventoryServersForUserQueryData>;
} {
  return {
    queryKey: queryKeyShadowMCPInventoryServersForUser({
      projectId: request.projectId,
      userKeys: request.userKeys,
      from: request.from,
      to: request.to,
      limit: request.limit,
      gramSession: request.gramSession,
    }),
    queryFn: async function shadowMCPInventoryServersForUserQueryFn(
      ctx,
    ): Promise<ShadowMCPInventoryServersForUserQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListShadowMCPInventoryServersForUser(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyShadowMCPInventoryServersForUser(
  parameters: {
    projectId: string;
    userKeys: Array<string>;
    from?: Date | undefined;
    to?: Date | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "access",
    "listShadowMCPInventoryServersForUser",
    parameters,
  ];
}
